import { Component, OnInit } from '@angular/core';
import { IonicModule, Platform } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LoginComponent, PageLayoutModule, RedirectService } from 'army-builder-shared';
import { filter, take } from 'rxjs';

import { WarlordUserService } from './user.service';

@Component({
    standalone: true,
    imports: [IonicModule, CommonModule, TranslateModule, PageLayoutModule, LoginComponent],
    selector: 'wl-login-page',
    template: `
        <abs-page-layout [pageTitle]="'GLOBAL.LOGIN.BUTTONS.LOGIN' | translate">
            <div class="content">
                <abs-login [showLogin]="true" [showRegister]="!platform.is('ios')"></abs-login>
            </div>
        </abs-page-layout>
    `
})
export class LoginPage implements OnInit {
    constructor(
        public platform: Platform,
        private userService: WarlordUserService,
        private redirectService: RedirectService
    ) {}

    ngOnInit() {
        this.userService.login$
            .pipe(
                filter((state) => !!state.user),
                take(1)
            )
            // Sends the user back to wherever prompted the login (e.g. UserGuard denying a
            // route, or a Register tap on a public event page) rather than always /home —
            // RedirectService already exists for exactly this and simply wasn't consulted here.
            .subscribe(() => this.redirectService.redirectAfterLogin('/home'));
    }
}
